import { render, staticRenderFns } from "./TabExternalUsers.vue?vue&type=template&id=1b25072c"
import script from "./TabExternalUsers.vue?vue&type=script&lang=ts"
export * from "./TabExternalUsers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports